import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

// components
import { RatingStars } from "../../ui/rating";
import { LoaderMUI } from "../../../assets/global/loader/loader-mui";
import { putResult } from "../../../services/api/results-api";

//style
import "./sidebar-results.css";
import { useResultsContext } from "../../../services/context/results-context";


export const ResultRating = ({ resultId, /* resultRating */ }) => {
  const { results, setResults } = useResultsContext();
  const selectedResult = results.find(r => r.resultId === resultId);
  const resultRating = selectedResult?.rating;
  const [rating, setRating] = useState(resultRating ?? 0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  
  const ratingHandler = (value) => {
    setRating(value);
    setLoading(true);
    fetchData(resultId, value);
  };

  const fetchData = async (resultId, ratingValue) => {
    if (!resultId) return;
    setLoading(true);
    setError(null);
    try {
      const responseData = await putResult(resultId, { rating: ratingValue });

      setResults(prev => prev.map(r=>r.resultId === resultId ? {...r, rating: ratingValue} : r))

    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    setRating(resultRating ?? 0)
  }, [resultId])

  return (
    <Box
      key={resultId + "rating"}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#EEEEF6",
        gap: "4px",
        width: "100%",
        borderRadius: "8px",
        padding: "8px",
      }}
    >
      <Typography color="#343745" fontSize="14px" fontWeight={700}>
        How do you rate this result?
      </Typography>

      {loading ? (
        <Box
          sx={{
            height: "28px",
            position: "relative",
          }}
        >
          <LoaderMUI size={20} />
        </Box>
      ) : (
        <RatingStars setValue={ratingHandler} value={rating} />
      )}
    </Box>
  );
};
